'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _model = require('../../../editor/model');

var _model2 = _interopRequireDefault(_model);

var _dom = require('../../../editor/dom');

var _serialize = require('../../../editor/serialize');

var _EventUtils = require('../../../utils/EventUtils');

var _deserialize = require('../../../editor/deserialize');

var _parts = require('../../../editor/parts');

var _EditorStateTransfer = require('../../../utils/EditorStateTransfer');

var _EditorStateTransfer2 = _interopRequireDefault(_EditorStateTransfer);

var _matrixJsSdk = require('matrix-js-sdk');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Keyboard = require('../../../Keyboard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
function _isReply(mxEvent) {
    var relatesTo = mxEvent.getContent()["m.relates_to"];
    var isReply = !!(relatesTo && relatesTo["m.in_reply_to"]);
    return isReply;
}

function getHtmlReplyFallback(mxEvent) {
    var html = mxEvent.getContent().formatted_body;
    if (!html) {
        return "";
    }
    var rootNode = new DOMParser().parseFromString(html, "text/html").body;
    var mxReply = rootNode.querySelector("mx-reply");
    return mxReply && mxReply.outerHTML || "";
}

function getTextReplyFallback(mxEvent) {
    var body = mxEvent.getContent().body;
    var lines = body.split("\n").map(function (l) {
        return l.trim();
    });
    if (lines.length > 2 && lines[0].startsWith("> ") && lines[1].length === 0) {
        return lines[0] + '\n\n';
    }
    return "";
}

function createEditContent(model, editedEvent) {
    var isEmote = (0, _serialize.containsEmote)(model);
    if (isEmote) {
        model = (0, _serialize.stripEmoteCommand)(model);
    }
    var isReply = _isReply(editedEvent);
    var plainPrefix = "";
    var htmlPrefix = "";

    if (isReply) {
        plainPrefix = getTextReplyFallback(editedEvent);
        htmlPrefix = getHtmlReplyFallback(editedEvent);
    }

    var body = (0, _serialize.textSerialize)(model);

    var newContent = {
        "msgtype": isEmote ? "m.emote" : "m.text",
        "body": body
    };
    var contentBody = {
        msgtype: newContent.msgtype,
        body: plainPrefix + ' * ' + body
    };

    var formattedBody = (0, _serialize.htmlSerializeIfNeeded)(model, { forceHTML: isReply });
    if (formattedBody) {
        newContent.format = "org.matrix.custom.html";
        newContent.formatted_body = formattedBody;
        contentBody.format = newContent.format;
        contentBody.formatted_body = htmlPrefix + ' * ' + formattedBody;
    }

    return (0, _assign2.default)({
        "m.new_content": newContent,
        "m.relates_to": {
            "rel_type": "m.replace",
            "event_id": editedEvent.getId()
        }
    }, contentBody);
}

var EditMessageComposer = function (_React$Component) {
    (0, _inherits3.default)(EditMessageComposer, _React$Component);

    function EditMessageComposer(props, context) {
        (0, _classCallCheck3.default)(this, EditMessageComposer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditMessageComposer.__proto__ || (0, _getPrototypeOf2.default)(EditMessageComposer)).call(this, props, context));

        _this._setEditorRef = function (ref) {
            _this._editorRef = ref;
        };

        _this._onKeyDown = function (event) {
            // ignore any keypress while doing IME compositions
            if (_this._editorRef.isComposing(event)) {
                return;
            }
            if (event.metaKey || event.altKey || event.shiftKey) {
                return;
            }
            if (event.key === _Keyboard.Key.ENTER) {
                _this._sendEdit();
                event.preventDefault();
            } else if (event.key === _Keyboard.Key.ESCAPE) {
                _this._cancelEdit();
            } else if (event.key === _Keyboard.Key.ARROW_UP) {
                if (_this._editorRef.isModified() || !_this._editorRef.isCaretAtStart()) {
                    return;
                }
                var previousEvent = (0, _EventUtils.findEditableEvent)(_this._getRoom(), false, _this.props.editState.getEvent().getId());
                if (previousEvent) {
                    _dispatcher2.default.dispatch({ action: 'edit_event', event: previousEvent });
                    event.preventDefault();
                }
            } else if (event.key === _Keyboard.Key.ARROW_DOWN) {
                if (_this._editorRef.isModified() || !_this._editorRef.isCaretAtEnd()) {
                    return;
                }
                var nextEvent = (0, _EventUtils.findEditableEvent)(_this._getRoom(), true, _this.props.editState.getEvent().getId());
                if (nextEvent) {
                    _dispatcher2.default.dispatch({ action: 'edit_event', event: nextEvent });
                } else {
                    _dispatcher2.default.dispatch({ action: 'edit_event', event: null });
                    _dispatcher2.default.dispatch({ action: 'focus_composer' });
                }
                event.preventDefault();
            }
        };

        _this._cancelEdit = function () {
            _dispatcher2.default.dispatch({ action: "edit_event", event: null });
            _dispatcher2.default.dispatch({ action: 'focus_composer' });
        };

        _this._sendEdit = function () {
            var editedEvent = _this.props.editState.getEvent();
            var editContent = createEditContent(_this.model, editedEvent);
            var newContent = editContent["m.new_content"];

            // If content is modified then send an updated event into the room
            if (_this._isContentModified(newContent)) {
                var roomId = editedEvent.getRoomId();
                _this._cancelPreviousPendingEdit();
                _this.context.matrixClient.sendMessage(roomId, editContent);
            }

            // close the event editing and focus composer
            _dispatcher2.default.dispatch({ action: "edit_event", event: null });
            _dispatcher2.default.dispatch({ action: 'focus_composer' });
        };

        _this._onChange = function () {
            if (!_this.state.saveDisabled || !_this._editorRef || !_this._editorRef.isModified()) {
                return;
            }

            _this.setState({
                saveDisabled: false
            });
        };

        _this.model = null;
        _this._editorRef = null;

        _this.state = {
            saveDisabled: true
        };
        return _this;
    }

    (0, _createClass3.default)(EditMessageComposer, [{
        key: '_getRoom',
        value: function _getRoom() {
            return this.context.matrixClient.getRoom(this.props.editState.getEvent().getRoomId());
        }
    }, {
        key: '_isContentModified',
        value: function _isContentModified(newContent) {
            // if nothing has changed then bail
            var oldContent = this.props.editState.getEvent().getContent();
            if (!this._editorRef.isModified() || oldContent["msgtype"] === newContent["msgtype"] && oldContent["body"] === newContent["body"] && oldContent["format"] === newContent["format"] && oldContent["formatted_body"] === newContent["formatted_body"]) {
                return false;
            }
            return true;
        }
    }, {
        key: '_cancelPreviousPendingEdit',
        value: function _cancelPreviousPendingEdit() {
            var originalEvent = this.props.editState.getEvent();
            var previousEdit = originalEvent.replacingEvent();
            if (previousEdit && (previousEdit.status === _matrixJsSdk.EventStatus.QUEUED || previousEdit.status === _matrixJsSdk.EventStatus.NOT_SENT)) {
                this.context.matrixClient.cancelPendingEvent(previousEdit);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // store caret and serialized parts in the
            // editorstate so it can be restored when the remote echo event tile gets rendered
            // in case we're currently editing a pending event
            var sel = document.getSelection();
            var caret = void 0;
            if (sel.focusNode) {
                caret = (0, _dom.getCaretOffsetAndText)(this._editorRef, sel).caret;
            }
            var parts = this.model.serializeParts();
            // if caret is undefined because for some reason there isn't a valid selection,
            // then when mounting the editor again with the same editor state,
            // it will set the cursor at the end.
            this.props.editState.setEditorState(caret, parts);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._createEditorModel();
        }
    }, {
        key: '_createEditorModel',
        value: function _createEditorModel() {
            var editState = this.props.editState;

            var room = this._getRoom();
            var partCreator = new _parts.PartCreator(room, this.context.matrixClient);
            var parts = void 0;
            if (editState.hasEditorState()) {
                // if restoring state from a previous editor,
                // restore serialized parts from the state
                parts = editState.getSerializedParts().map(function (p) {
                    return partCreator.deserializePart(p);
                });
            } else {
                // otherwise, parse the body of the event
                parts = (0, _deserialize.parseEvent)(editState.getEvent(), partCreator);
            }
            this.model = new _model2.default(parts, partCreator);
        }
    }, {
        key: '_getInitialCaretPosition',
        value: function _getInitialCaretPosition() {
            var editState = this.props.editState;

            var caretPosition = void 0;
            if (editState.hasEditorState() && editState.getCaret()) {
                // if restoring state from a previous editor,
                // restore caret position from the state
                var caret = editState.getCaret();
                caretPosition = this.model.positionForOffset(caret.offset, caret.atNodeEnd);
            } else {
                // otherwise, set it at the end
                caretPosition = this.model.getPositionAtEnd();
            }
            return caretPosition;
        }
    }, {
        key: 'render',
        value: function render() {
            var BasicMessageComposer = _index2.default.getComponent('rooms.BasicMessageComposer');
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)("mx_EditMessageComposer", this.props.className), onKeyDown: this._onKeyDown },
                _react2.default.createElement(BasicMessageComposer, {
                    ref: this._setEditorRef,
                    model: this.model,
                    room: this._getRoom(),
                    initialCaret: this.props.editState.getCaret(),
                    label: (0, _languageHandler._t)("Edit message"),
                    onChange: this._onChange
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_EditMessageComposer_buttons' },
                    _react2.default.createElement(
                        AccessibleButton,
                        { kind: 'secondary', onClick: this._cancelEdit },
                        (0, _languageHandler._t)("Cancel")
                    ),
                    _react2.default.createElement(
                        AccessibleButton,
                        { kind: 'primary', onClick: this._sendEdit, disabled: this.state.saveDisabled },
                        (0, _languageHandler._t)("Save")
                    )
                )
            );
        }
    }]);
    return EditMessageComposer;
}(_react2.default.Component);

EditMessageComposer.propTypes = {
    // the message event being edited
    editState: _propTypes2.default.instanceOf(_EditorStateTransfer2.default).isRequired
};
EditMessageComposer.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};
exports.default = EditMessageComposer;
module.exports = exports['default'];
//# sourceMappingURL=EditMessageComposer.js.map